import CloudsSVG from "../../components/weather/images/clouds.svg";
import DewPointSVG from "../../components/weather/images/dew-point.svg";
import GustSVG from "../../components/weather/images/gust.svg";
import HumiditySVG from "../../components/weather/images/humidity.svg";
import PressureSVG from "../../components/weather/images/pressure.svg";
import RainfallSVG from "../../components/weather/images/rainfall.svg";
import TemperatureSVG from "../../components/weather/images/temperature.svg";
import VisibilitySVG from "../../components/weather/images/visibility-range.svg";
import WindSVG from "../../components/weather/images/wind.svg";

export const WEATHER_SUMMARY_TABLE_COLUMNS = [
  {
    key: "name",
    name: "Name",
    fieldName: "name",
    minWidth: 100,
    maxWidth: 100,
  },
  {
    key: "value",
    name: "Value",
    fieldName: "value",
    minWidth: 100,
    maxWidth: 100,
  },
];

export const runwayImages: Record<string, string> = {
  "06_24": require("../../components/common/images/runways/06R_24L.svg")
    .default,
  "09L_27R": require("../../components/common/images/runways/09L_27R.svg")
    .default,
  "09R_27L": require("../../components/common/images/runways/09R_27L.svg")
    .default,
  "11_29": require("../../components/common/images/runways/11R_29L.svg")
    .default,
  // add others here
};

export const WEATHER_SUMMARY_LEFT_TABLE_KEYS = [
  {
    name: "clouds",
    displayName: "Cloud Cover",
    image: CloudsSVG,
  },
  {
    name: "visibility",
    displayName: "Visibility",
    image: VisibilitySVG,
  },
  {
    name: "wind",
    displayName: "Wind",
    image: WindSVG,
  },
  {
    name: "humidity",
    displayName: "Humidity",
    image: HumiditySVG,
  },
  {
    name: "rainfall",
    displayName: "Rainfall",
    image: RainfallSVG,
  },
];
export const STATUS_COLOR_MAP = {
  Normal: "#28a745",
  RVOP: "#ffbe0b",
  LVOP: "#dc3545",
};
export const WEATHER_SUMMARY_RIGHT_TABLE_KEYS = [
  {
    name: "pressure",
    displayName: "Pressure",
    image: PressureSVG,
  },
  {
    name: "gust",
    displayName: "Gust",
    image: GustSVG,
  },
  {
    name: "dewPoint",
    displayName: "Dew Point",
    image: DewPointSVG,
  },
];

export const WEATHER_KPI_CARD_KEYS = [
  {
    name: "temperature",
    displayName: "Temperature",
    image: TemperatureSVG,
  },
  {
    name: "humidity",
    displayName: "Humidity",
    image: HumiditySVG,
  },
  {
    name: "precipitation",
    displayName: "Precipitation",
    image: RainfallSVG,
  },
  {
    name: "wind",
    displayName: "Wind",
    image: WindSVG,
  },
  {
    name: "visibility",
    displayName: "Visibility Range",
    image: VisibilitySVG,
  },
  {
    name: "cloudCeiling",
    displayName: "Cloud Ceiling",
    image: CloudsSVG,
  },
  {
    name: "dewPoint",
    displayName: "Dew Point",
    image: DewPointSVG,
  },
  {
    name: "pressure",
    displayName: "Pressure",
    image: PressureSVG,
  },
];

export const WEATHER_KPI_TABS = {
  data: [{ text: "TODAYS WEATHER", name: "today", value: "today" }],
};

export const WEATHER_GRAPH_TABS = {
  data: [
    {
      text: "Temperature",
      name: "temperature",
      value: "temperature",
      image: TemperatureSVG,
    },
    { text: "Humidity", name: "humidity", value: "humidity", image: CloudsSVG },
    {
      text: "Rainfall",
      name: "rainfall",
      value: "rainfall",
      image: RainfallSVG,
    },
    { text: "Wind", name: "windSpeed", value: "windSpeed", image: WindSVG },
    {
      text: "Visibility Range",
      name: "visibility",
      value: "visibility",
      image: VisibilitySVG,
    },
    {
      text: "Clouds",
      name: "cloudCover",
      value: "cloudCover",
      image: RainfallSVG,
    },
    {
      text: "Dew Point",
      name: "dewPoint",
      value: "dewPoint",
      image: DewPointSVG,
    },
  ],
};

export const SPEED_GAUGE_PROPS = {
  extended: { ringWidth: 13, width: 200, needleHeight: 0.7 },
  runway: { ringWidth: 17, width: 300, needleHeight: 0.8 },
};

export const SPEEDGAUGE_SEGMENT_COLORS = [
  "#008540",
  "#FEEB3D",
  "#F7A827",
  "#E95326",
  "#CE0058",
];

export const SPEEDGAUGE_SEGMENT_STOPS = [0, 32.1, 40.2, 62.7, 91.7, 130];

/** Controls which columns include the "anchor" label (weekday + time). */
export type AnchorAt = "all" | "midnight" | "every6hours" | "every12hours";
